import { TextButton } from '@shared/ui/index.ts';
import * as st from './styles.module.scss';

interface Props {
  onReset: () => void;
  onConfirm: () => void;
  isFilterActive: boolean;
}

export const FilterMobileActions = ({ onReset, onConfirm, isFilterActive }: Props): JSX.Element => {
  return (
    <div className={st.actions}>
      <TextButton
        className={st.throwOff}
        size="medium"
        onClick={() => onReset()}
        disabled={!isFilterActive}
      >
        Сбросить
      </TextButton>
      <TextButton size="medium" onClick={onConfirm} className={st.actions__done}>
        Готово
      </TextButton>
    </div>
  );
};
